import React from 'react';
import Button from '../ui/Button';
import ScrollReveal from '../ui/ScrollReveal';
import { ArrowRight, CheckCircle, Play } from 'lucide-react';
interface CTASectionProps {
  onWatchDemo: () => void;
}
const CTASection: React.FC<CTASectionProps> = ({
  onWatchDemo
}) => {
  return <section className="py-24 px-6 md:px-12 lg:px-24 bg-gradient-to-br from-[#3D52A0] to-[#7091E6] text-white relative overflow-hidden" data-id="element-227">
      {/* Background patterns */}
      <div className="absolute inset-0 opacity-10" data-id="element-228">
        <div className="absolute inset-0" style={{
        backgroundImage: 'radial-gradient(circle, white 1px, transparent 1px)',
        backgroundSize: '30px 30px'
      }} data-id="element-229"></div>
      </div>
      <div className="absolute top-0 right-0 w-1/2 h-1/2 bg-white opacity-5 rounded-full filter blur-3xl transform translate-x-1/3 -translate-y-1/3" data-id="element-230"></div>
      <div className="absolute bottom-0 left-0 w-1/2 h-1/2 bg-white opacity-5 rounded-full filter blur-3xl transform -translate-x-1/3 translate-y-1/3" data-id="element-231"></div>
      <div className="max-w-7xl mx-auto text-center relative z-10" data-id="element-232">
        <ScrollReveal data-id="element-233">
          <span className="inline-block px-4 py-1 bg-white/10 rounded-full text-sm font-medium mb-6 backdrop-blur-sm" data-id="element-234">
            Made withby your friends at Text In Church.
          </span>
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-235">
            Shepherd Flow AI is free and built to help every church communicate
            better, love deeper, and reach farther.
          </h2>
          <p className="text-xl md:text-2xl mb-10 opacity-90 max-w-2xl mx-auto" data-id="element-236">
            Start today and turn every outreach event into lasting impact.
          </p>
        </ScrollReveal>
        <ScrollReveal delay={300} data-id="element-237">
          <div className="flex flex-col sm:flex-row gap-6 justify-center mb-12" data-id="element-238">
            <a href="https://app.shepherdflow.ai/signup" data-id="element-239">
              <Button variant="accent" size="lg" icon={<ArrowRight size={18} data-id="element-241" />} className="bg-white text-[#3D52A0] hover:bg-[#EDE8F5] shadow-lg shadow-[#3D52A0]/20" data-id="element-240">
                Start Free
              </Button>
            </a>
            <Button variant="secondary" size="lg" icon={<Play size={18} data-id="element-243" />} className="bg-white/20 border-white text-white hover:bg-white/30" onClick={onWatchDemo} data-id="element-242">
              Watch Demo
            </Button>
          </div>
          {/* Trust indicators */}
          <div className="flex flex-wrap justify-center gap-6 mb-16" data-id="element-244">
            <div className="flex items-center gap-2" data-id="element-245">
              <CheckCircle size={20} className="text-[#EDE8F5]" data-id="element-246" />
              <span data-id="element-247">No cost. No setup. No stress.</span>
            </div>
          </div>
        </ScrollReveal>
        <ScrollReveal delay={500} data-id="element-248">
          <div className="bg-white/10 backdrop-blur-sm p-8 rounded-xl border border-white/20 max-w-3xl mx-auto transform hover:-translate-y-1 transition-transform duration-300" data-id="element-249">
            <h3 className="text-2xl font-bold mb-8 text-center" data-id="element-250">
              Trusted Partnership
            </h3>
            <div className="grid md:grid-cols-2 gap-8" data-id="element-251">
              <div className="text-center md:text-left bg-white/5 p-6 rounded-lg" data-id="element-252">
                <p className="font-medium text-lg mb-1" data-id="element-253">Powered by Gloo AI</p>
                <p className="opacity-80 text-sm" data-id="element-254">
                  Advanced AI technology designed for ministry impact.
                </p>
              </div>
              <div className="text-center md:text-left bg-white/5 p-6 rounded-lg" data-id="element-255">
                <p className="font-medium text-lg mb-1" data-id="element-256">
                  Built by Text In Church
                </p>
                <p className="opacity-80 text-sm" data-id="element-257">
                  10+ years of helping churches communicate with clarity and
                  care.
                </p>
              </div>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>;
};
export default CTASection;